//https://github.com/redux-utilities/redux-actions
import { createActions, handleActions } from 'redux-actions'

const localStorageKey = 'codigoliberacao'

const initialState = {
  codigo: ''
}
//o reducer começa assim
const defaultState = window.localStorage.getItem(localStorageKey) ? JSON.parse(window.localStorage.getItem(localStorageKey)) : initialState

//tem uma ação para salvar
export const { codigoliberacaoReset, codigoliberacaoSave } = createActions({
   CODIGOLIBERACAO_RESET: () => ({  }),
   CODIGOLIBERACAO_SAVE: (value) => ({ value })
})


//função de salvar
export const codigoliberacao = handleActions(
    {
      [codigoliberacaoSave]: (state, { payload: { value } }) => {
        console.log('------------', value)
        window.localStorage.setItem(localStorageKey, JSON.stringify({codigo: value.codigo }))
        
        return { ...state, codigo: value.codigo }
      },
      [codigoliberacaoReset]: (state) => {
        //console.log('------------', value)
        window.localStorage.removeItem(localStorageKey)
        return { ...state, codigo: '' }
      }
    },
    defaultState
  )